"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconClockRefresh = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconClockRefresh = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.5407 5.67501L19.432 6.08054C16.553 2.45679 11.3788 1.38918 7.25011 3.77288C4.5146 5.35222 2.86232 8.08739 2.55215 11.0015C2.49369 11.5506 2.8915 12.0432 3.44068 12.1017C3.98987 12.1601 4.48245 11.7623 4.54091 11.2131C4.78634 8.90741 6.09163 6.75113 8.25011 5.50493C11.406 3.68289 15.3356 4.41507 17.6452 7.06005L17.3013 6.9679C16.7678 6.82496 16.2195 7.14154 16.0766 7.67501C15.9336 8.20847 16.2502 8.75681 16.7837 8.89975L19.5157 9.6318C20.0492 9.77475 20.5975 9.45816 20.7405 8.9247L21.4725 6.19265C21.6155 5.65918 21.2989 5.11084 20.7654 4.9679C20.2319 4.82496 19.6836 5.14154 19.5407 5.67501Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.5594 11.8984C21.1086 11.9569 21.5064 12.4495 21.4479 12.9986C21.1378 15.9127 19.4855 18.6479 16.75 20.2272C12.6212 22.611 7.44688 21.5433 4.56792 17.9194L4.45934 18.3246C4.3164 18.8581 3.76806 19.1746 3.23459 19.0317C2.70113 18.8888 2.38454 18.3404 2.52749 17.807L3.25954 15.0749C3.40248 14.5414 3.95082 14.2249 4.48428 14.3678L7.21633 15.0999C7.7498 15.2428 8.06638 15.7911 7.92344 16.3246C7.7805 16.8581 7.23216 17.1746 6.6987 17.0317L6.35434 16.9394C8.66387 19.5849 12.5939 20.3173 15.75 18.4952C17.9084 17.249 19.2137 15.0927 19.4592 12.787C19.5176 12.2378 20.0102 11.84 20.5594 11.8984Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.0001 7.49993C13.0001 6.94765 12.5523 6.49993 12.0001 6.49993C11.4478 6.49993 11.0001 6.94765 11.0001 7.49993V11.9999C11.0001 12.3512 11.1844 12.6767 11.4856 12.8574L13.9856 14.3574C14.4591 14.6416 15.0734 14.488 15.3575 14.0144C15.6417 13.5408 15.4881 12.9266 15.0145 12.6424L13.0001 11.4337V7.49993Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.4532 12.8928C20.1754 15.5027 18.6967 17.9484 16.2497 19.3612C12.1842 21.7084 6.98566 20.3155 4.63845 16.25L4.38845 15.817M3.54617 11.1071C3.82397 8.49723 5.30276 6.05151 7.74974 4.63874C11.8152 2.29153 17.0138 3.68447 19.361 7.74995L19.611 8.18297M3.49316 18.0659L4.22522 15.3339L6.95727 16.0659M17.0422 7.93398L19.7743 8.66603L20.5063 5.93398M11.9997 7.49995V12L14.4997 13.5",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconClockRefresh = IconClockRefresh;
//# sourceMappingURL=IconClockRefresh.js.map